<template>
  <div>
    <v-progress-linear v-if="loading" indeterminate color="primary" class="mb-2" />
    <table class="table table-bordered table-hover">
      <thead>
        <tr>
          <th class="text-center">STT</th>
          <th class="text-center">ID</th>
          <th class="text-center">Ngày giao dịch</th>
          <th class="text-center">Loại</th>
          <th class="text-right">Số tiền</th>
          <th class="text-center">Nợ</th>
          <th class="text-center">Có</th>
          <th class="text-left">Diễn giải</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(t, idx) in transactions" :key="t.id">
          <td class="text-center">{{ idx + 1 }}</td>
          <td class="text-center">{{ t.referenceCode }}</td>
          <td class="text-center">{{ formatDate(t.createdAt, 'DD/MM/YYYY HH:mm') }}</td>
          <td class="text-center">{{ t.typeName }}</td>
          <td class="text-right">{{ convertPrice(t.amount) }}</td>
          <td class="text-center">{{ t.accountantCode }}</td>
          <td class="text-center">{{ t.accountantRefCode }}</td>
          <td class="text-left">{{ t.note }}</td>
        </tr>
        <tr v-if="!loading && transactions.length === 0">
          <td colspan="8" class="text-center grey--text">
            Chưa có bút toán nào liên quan.
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { formatDate, convertPrice } from '@/utils/common';
import PurchaseOrderService from '@/core/api/purchase-order/purchase-order.service';

export default {
  name: 'POTransactionPanel',
  props: {
    purchaseOrderId: { type: [Number, String], required: true },
    mode: { type: String, default: 'single' }, // 'single' | 'aggregate'
  },
  data() {
    return {
      transactions: [],
      loading: false,
    };
  },
  watch: {
    purchaseOrderId: {
      immediate: true,
      handler(val) {
        if (val) this.fetchData();
      },
    },
  },
  methods: {
    async fetchData() {
      this.loading = true;
      try {
        const fetcher =
          this.mode === 'aggregate'
            ? PurchaseOrderService.listTransactionsAggregate(this.purchaseOrderId)
            : PurchaseOrderService.listTransactions(this.purchaseOrderId);
        const res = await fetcher;
        // ResponseInterceptor wrap: res.data = { status, statusCode, message, data }
        this.transactions = res?.data?.data || [];
      } catch (e) {
        this.transactions = [];
      } finally {
        this.loading = false;
      }
    },
    formatDate,
    convertPrice,
  },
};
</script>

<style scoped>
.table {
  width: 100%;
}
</style>
